import '../styles/index.scss';
import home from './home';
import offer from './offer';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            home.init();
            offer.init();
            this.initNav();
        });
    }

    initNav() {
        // --- Scroll: transparent → bg-background/95 ---
        const nav = document.querySelector('[data-nav]');
        if (nav) {
            const onScroll = () => {
                if (window.scrollY > 50) {
                    nav.classList.add('scrolled');
                } else {
                    nav.classList.remove('scrolled');
                }
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        // --- Desktop Obozy dropdown ---
        const dropdown = document.querySelector('[data-dropdown]');
        if (dropdown) {
            const toggle  = dropdown.querySelector('[data-dropdown-toggle]');
            const menu    = dropdown.querySelector('[data-dropdown-menu]');
            const chevron = dropdown.querySelector('[data-chevron]');

            toggle.addEventListener('click', (e) => {
                e.stopPropagation();
                const isOpen = !menu.classList.contains('hidden');
                menu.classList.toggle('hidden', isOpen);
                chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
                toggle.setAttribute('aria-expanded', String(!isOpen));
            });

            document.addEventListener('mousedown', (e) => {
                if (!dropdown.contains(e.target)) {
                    menu.classList.add('hidden');
                    chevron.style.transform = '';
                    toggle.setAttribute('aria-expanded', 'false');
                }
            });
        }

        // --- Mobile toggle (hamburger ↔ X) ---
        const mobileToggle = document.querySelector('[data-mobile-toggle]');
        const mobileMenu   = document.querySelector('[data-mobile-menu]');
        const iconMenu     = document.querySelector('[data-icon-menu]');
        const iconClose    = document.querySelector('[data-icon-close]');

        if (mobileToggle && mobileMenu) {
            mobileToggle.addEventListener('click', () => {
                const isOpen = !mobileMenu.classList.contains('hidden');
                mobileMenu.classList.toggle('hidden', isOpen);
                iconMenu.classList.toggle('hidden', !isOpen);
                iconClose.classList.toggle('hidden', isOpen);
            });
        }

        // --- Mobile Obozy dropdown ---
        const mobileDropdownToggle = document.querySelector('[data-mobile-dropdown-toggle]');
        const mobileDropdownMenu   = document.querySelector('[data-mobile-dropdown-menu]');
        const mobileChevron        = document.querySelector('[data-mobile-chevron]');

        if (mobileDropdownToggle && mobileDropdownMenu) {
            mobileDropdownToggle.addEventListener('click', () => {
                const isOpen = !mobileDropdownMenu.classList.contains('hidden');
                mobileDropdownMenu.classList.toggle('hidden', isOpen);
                mobileDropdownMenu.classList.toggle('flex', !isOpen);
                mobileChevron.style.transform = isOpen ? '' : 'rotate(180deg)';
            });
        }
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();
